import styled from 'styled-components'
import { BadgeProps } from './Badge.types'

const getVariantStyles = (variant: BadgeProps['variant'], theme: any) => {
  switch (variant) {
    case 'success':
      return {
        backgroundColor: theme.colors.tags.green,
        color: theme.colors.success,
      }
    case 'warning':
      return {
        backgroundColor: theme.colors.tags.orange,
        color: theme.colors.warning,
      }
    case 'danger':
      return {
        backgroundColor: theme.colors.tags.red,
        color: theme.colors.danger,
      }
    case 'info':
      return {
        backgroundColor: theme.colors.tags.blue,
        color: theme.colors.primary,
      }
    case 'primary':
      return {
        backgroundColor: theme.colors.primaryLight,
        color: theme.colors.primary,
      }
    case 'secondary':
      return {
        backgroundColor: theme.colors.tags.gray,
        color: theme.colors.text.secondary,
      }
    default:
      return {
        backgroundColor: theme.colors.background.tertiary,
        color: theme.colors.text.secondary,
      }
  }
}

export const StyledBadge = styled.span<{
  $variant: BadgeProps['variant']
  $size?: BadgeProps['size']
}>`
  display: inline-flex;
  align-items: center;
  padding: ${({ theme, $size }) =>
    $size === 'small'
      ? '2px 6px'
      : theme.components.badge.padding || '4px 8px'};
  font-size: ${({ theme, $size }) =>
    $size === 'small' ? '10px' : theme.components.badge.fontSize || '11px'};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  line-height: 1;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  text-transform: uppercase;
  letter-spacing: ${({ theme }) => theme.typography.letterSpacing.uppercase};
  white-space: nowrap;
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};

  ${({ $variant, theme }) => {
    const styles = getVariantStyles($variant, theme)
    return `
      background-color: ${styles.backgroundColor};
      color: ${styles.color};
    `
  }}
`
